<template>
  <div>

    <div v-if="epreuve.id && updating" id="update-screen">
      <v-icon name="sync" scale="4" spin style="color: #a0a0a0; opacity: 0.5" />
      <p style="margin-top: 15px; color: #a0a0a0; font-size: 2em">
        Mise à jour de {{ epreuve.nom_epreuve }} en cours...

      </p>
    </div>
    <div v-else-if="epreuve.id && !updating" id="update-screen">
      <v-icon name="check" scale="4" style="color: #a0a0a0; opacity: 0.5" />
      <p style="margin-top: 15px; color: #a0a0a0; font-size: 2em">
        Mise à jour de {{ epreuve.nom_epreuve }} terminée
      </p>
      <b-button size="sm" style="margin-bottom: 5px"><router-link :to="{ name: 'Admin' }" style="color: inherit">Retour
          à l'administration</router-link></b-button>
    </div>
    <div v-else id="update-screen">
      <v-icon name="sync" scale="4" spin style="color: #a0a0a0; opacity: 0.5" />
      <p style="margin-top: 15px; color: #a0a0a0; font-size: 2em">
        Chargement de l'épreuve en cours...
      </p>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      epreuve: {},
      updating: true,
    };
  },
  methods: {
    launchUpdate() {
      var _this = this;
      const data = { "url_export": this.epreuve.url_export };
      Axios.post(this.$store.getters.base_url + "/import/results/emptyResults.php", data).then(function (response) {
        _this.pausecomp(2000);
        console.log(response);
        _this.updating = false;
      })
    },
    pausecomp(millis) {
      var date = new Date();
      var curDate = null;
      do { curDate = new Date(); }
      while (curDate - date < millis);
    }
  },
  created() {
    var _this = this;
    if (this.$route.query.id) {
      Axios.get(
        this.$store.getters.base_url + "/import/epreuve/get.php?id=" +
        this.$route.query.id
      ).then(function (response) {
        _this.pausecomp(2000);
        _this.epreuve = response.data;
        if (_this.epreuve.url_export) {
          _this.launchUpdate();
        }
      });
    }
  },
};
</script>

<style scoped>
#update-screen {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 1000000;
  background-color: #e7e7e7 !important;
  opacity: 1;
}
</style>
